import React from 'react';
import { Hero } from '../components/Hero';
import { HomeCallMoment } from '../components/HomeCallMoment';
import { ValueStrip } from '../components/ValueStrip';
import { SystemMapSection } from '../components/SystemMapSection';
import { QualificationBand } from '../components/QualificationBand';
import { NextStepPanel } from '../components/NextStepPanel';
import { usePageTitle } from '../hooks/usePageTitle';
export function Home() {
  usePageTitle('Viridia Analytics | Your team already pays for the tools. I make them produce.');
  return <>
      <Hero data-id="element-549" data-mp="24j4uuj99s297" />
      <HomeCallMoment data-id="element-550" data-mp="29g4xslatoow3" />
      <ValueStrip data-id="element-551" data-mp="29flofsz8n8to" />
      <SystemMapSection surface="ink-800" data-id="element-552" data-mp="29f2byrscxcn1" />
      <QualificationBand data-id="element-553" data-mp="29ihobmunc7kr" />
      <NextStepPanel title="Already tried an AI assistant and turned it off? Good. See why this is not that." buttonLabel="Why this is different" to="/why" secondaryLabel="Or book the free Response Audit" secondaryTo="/book" data-id="element-554" data-mp="2di8cdissg9ll" />
    </>;
}